import { CookieKey, EUCountryCodes } from '@/constants';

type BuildGtagBootstrapScript = (args: { pmId: string; pmcId: string; origin: string }) => string;

export const buildGtagBootstrapScript: BuildGtagBootstrapScript = ({ pmId, pmcId, origin }) => `
  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('consent', 'default', {
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'ad_storage': 'granted',
    'analytics_storage': 'granted',
  });

  gtag('consent', 'default', {
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'region': [
      'US-CA',
      ${EUCountryCodes.map((countryCode) => `'${countryCode}'`).join(',')}
    ],
  });

  function setGaCookie(key, value) {
    if (!key || !value) return;
    document.cookie = key + '=' + value + '; path=/; max-age=86400';
  }

  gtag('set', 'linker', {
    'domains': ['${origin}']
  });
  gtag('js', new Date());
  gtag('config', '${pmId}');

  gtag('get', '${pmId}', 'session_id', function(id) {
    setGaCookie('${CookieKey.Ga4SessionId}_${pmId}', id);
  });

  var pmcSessionIdRequested = false;
  function requestPmcSessionId() {
    if (pmcSessionIdRequested) return;
    pmcSessionIdRequested = true;
    gtag('get', '${pmcId}', 'session_id', function(id) {
      setGaCookie('${CookieKey.Ga4SessionId}_${pmcId}', id);
    });
  }
  if (window.google_tag_manager && window.google_tag_manager['${pmcId}']) {
    requestPmcSessionId();
  } else {
    window.addEventListener('gtm_loaded', requestPmcSessionId);
  }

  // Note: We only need to use one representative container (GA4 Measurement ID) to get the client_id.
  // The client_id value is shared across all containers on the same domain, as it is stored in the _ga cookie.
  // Therefore, there is no need to store or retrieve client_id separately for each container ID.

  gtag('get', '${pmId}', 'client_id', function(id) {
    setGaCookie('${CookieKey.Ga4ClientId}', id);
  });
`;
